import { faHome } from "@fortawesome/pro-duotone-svg-icons/faHome";

import { type Breadcrumb } from "@application/types/breadcrumb";

export const DASHBOARD_LINK: Breadcrumb = {
  icon: faHome,
  name: "Dashboard",
  to: "/dashboard",
};
